// utils/tenant.js
import { Link } from "react-router-dom";
import DefaultData from "../CompanyData/DefaultData";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade } from "swiper/modules";
import { motion } from "framer-motion";
import "swiper/css";
import "swiper/css/effect-fade";
//import "./GlobalSupplier.css"; // Import the CSS file
const supplierLogos = [
  "tbo.png",
  "tripjack.png",
  "airiq.png",
  "Riya.png",
  "rezlive.png",
];
export default function LoginScreenLeftSide() {
  const featureSlides = [
  {
    title: "Launch Your Travel Website with",
    subtitle: "Your Own Supplier APIs",
    desc: "Connect with leading travel suppliers TBO, TripJack, Riya, Akbar and many more."
  },
  {
    title: "Compare Prices from 50+ Suppliers",
    subtitle: "Find the Cheapest Flight Instantly",
    desc: "Instantly compare TripJack, TBO, Riya, Mystifly and more."
  },
  {
    title: "AI Powered Itinerary Builder",
    subtitle: "Create Complete Trips in Seconds",
    desc: "Generate full travel itineraries with flights, hotels and activities instantly."
  },
  {
    title: "WhatsApp AI Chatbot",
    subtitle: "Convert Enquiries into Bookings",
    desc: "Automatically respond to customer queries and capture leads 24/7."
  },
  {
    title: "Built-in Travel CRM",
    subtitle: "Manage Leads & Customers Easily",
    desc: "Track enquiries, manage bookings and grow your travel business."
  },
  {
    title: "Accounting + Reports",
    subtitle: "Track Your Profit in Real-Time",
    desc: "Invoices, balance tracking and financial reports in one dashboard."
  }
];
  return (
    <div style={{ maxWidth: "700px", paddingLeft:"10px" }}>
      <Swiper
        modules={[Autoplay, EffectFade]}
        autoplay={{ delay: 10000 }}
        effect="fade"
        fadeEffect={{ crossFade: true }}
        loop={true}
      >
        {featureSlides.map((slide, index) => (
          <SwiperSlide key={index}>
              <div className="globalsupplier-hero-badge">
                <i className="ri-handshake-line"></i>
                PRE INTEGRATED SUPPLIERS
              </div>
              <h2 className="globalsupplier-hero-title">
                {slide.title}
                <span className="globalsupplier-gradient-text">
                  {slide.subtitle}
                </span>
              </h2>
              <p className="text-white">{slide.desc}</p>
              <div className="globalsupplier-price-highlight">
                <div className="globalsupplier-price-badge">
                  💰 Save 70% on integration costs
                </div>
              </div>
          </SwiperSlide>
        ))}
      </Swiper>
      <div className="globalsupplier-price-highlight">
        <div className="globalsupplier-price-tag">
          <span className="globalsupplier-price-label">
            Price Starting from
          </span>
          <span className="globalsupplier-price-value">2,999</span>
          <span className="globalsupplier-price-period">INR/month</span>
        </div>
        <div
          className="globalsupplier-hero-ctas"
          style={{ marginBottom: "0px" }}
        >
          <Link to="/" className="globalsupplier-hero-cta-primary">
            Start Free Trial <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>

      {/* Trust Badges */}
      <div className="globalsupplier-trust-badges">
        <div className="globalsupplier-trust-item">
          <i className="ri-shield-check-line"></i>
          <span>No Credit Card Required</span>
        </div>
        <div className="globalsupplier-trust-item">
          <i className="ri-time-line"></i>
          <span>5-min Setup</span>
        </div>
        <div className="globalsupplier-trust-item">
          <i className="ri-customer-service-line"></i>
          <span>24/7 Support</span>
        </div>
      </div>
    </div>
  );
}
